import {ChecklistTemplateKind, type ChecklistDto} from '@domain/hroc-checklists'
import {type TFunction} from 'i18next'

import type {
  ChecklistFormValues,
  TakeFiveChecklistFormValues,
  KilnCheckSheetChecklistFormValues
} from '../types'

import {
  mapKilnCheckSheetChecklistDtoToFormValues,
  mapKilnChecksheetChecklistFormValuesToDataDto
} from './kiln-check-sheets.mappers'
import {
  mapTakeFiveChecklistDtoToFormValues,
  mapTakeFiveChecklistFormValuesToDataDto
} from './take-five.mappers'

export const mapChecklistDtoToChecklistFormValues = (
  checklist: ChecklistDto,
  t: TFunction
): ChecklistFormValues => {
  switch (checklist.kind) {
    case ChecklistTemplateKind.TakeFive:
      return mapTakeFiveChecklistDtoToFormValues(checklist, t)
    case ChecklistTemplateKind.KilnCheckSheet:
      return mapKilnCheckSheetChecklistDtoToFormValues(checklist)
    default:
      throw new Error(`Unknown checklist template kind: ${(checklist as ChecklistDto).kind}`)
  }
}

export const mapChecklistFormValuesToChecklistDtoData = (
  formValues: ChecklistFormValues,
  templateKind: ChecklistTemplateKind
): ChecklistDto['data'] => {
  switch (templateKind) {
    case ChecklistTemplateKind.TakeFive:
      return mapTakeFiveChecklistFormValuesToDataDto(formValues as TakeFiveChecklistFormValues)
    case ChecklistTemplateKind.KilnCheckSheet:
      return mapKilnChecksheetChecklistFormValuesToDataDto(
        formValues as KilnCheckSheetChecklistFormValues
      )
    default:
      throw new Error(`Unknown checklist template kind: ${templateKind}`)
  }
}
